export default __webpack_public_path__ + "static/media/poi_fireStationForest_multi.0f49874c.svg";